import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SignMessRequestsService } from 'services/signMessRequests/sign-mess-requests.service';
import { SignMessRequests } from 'domain-models/SignMessRequests';
import { Helper } from 'libraries/Helper';
import { ActivityLog } from 'domain-models/ActivityLog';
import { ActivityLogService } from 'services/activity-log/activity-log.service';

interface ActivityLogFormatted extends ActivityLog {
	formattedTime: string;
	signIpPort: string;
}

@Component({
	selector: 'activity-log-cmp',
	moduleId: module.id,
	templateUrl: './activity-log.component.html',
	styleUrls: ['./activity-log.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class ActivityLogComponent implements OnInit {
	public activityLogs: ActivityLogFormatted[];
	loading: Boolean = false;
	yearFilter: string;
	totalData: number = 0;
	defaultValue = { label: 'All', value: '%' };
	filters = {
		username: [this.defaultValue],
		action: [this.defaultValue],
		signId: [this.defaultValue],
		detail: [this.defaultValue],
		priority: [this.defaultValue],
		success: [this.defaultValue],
		commResult: [this.defaultValue],
		address: [this.defaultValue]
	};
	selectedFilters = {
		username: this.defaultValue.value,
		action: this.defaultValue.value,
		signId: this.defaultValue.value,
		detail: this.defaultValue.value,
		priority: this.defaultValue.value,
		success: this.defaultValue.value,
		commResult: this.defaultValue.value,
		address: this.defaultValue.value
	};
	currentPage = 0;
	pageSize = 25;

	timer;

	/**
	 *
	 */
	constructor(private activityLogService: ActivityLogService) {}
	ngOnInit() {
		this.loading = true;

		this.loadData();
		this.loadUnique();
	}

	loadUnique() {
		this.activityLogService.unique().subscribe((data) => {
			this.filters.username = [
				this.defaultValue,
				...data.username.map((v) => ({ label: v, value: v }))
			];
			this.filters.action = [
				this.defaultValue,
				...data.action.map((v) => ({ label: v, value: v }))
			];
			this.filters.signId = [
				this.defaultValue,
				...data.signId.map((v) => ({ label: v, value: v }))
			];
			this.filters.detail = [
				this.defaultValue,
				...data.detail.map((v) => ({ label: v, value: v }))
			];
			this.filters.priority = [
				this.defaultValue,
				...data.priority.map((v) => ({ label: v, value: v }))
			];
			this.filters.success = [
				this.defaultValue,
				...data.success.map((v) => ({ label: v, value: v }))
			];
			this.filters.address = [
				this.defaultValue,
				...data.address.map((v) => ({ label: v, value: v }))
			];
			this.filters.commResult = [
				this.defaultValue,
				...data.commResult.map((v) => ({ label: v, value: v }))
			];
		});
	}

	loadData() {
		this.loading = true;
		this.activityLogService.count(this.selectedFilters).subscribe((data) => {
			this.totalData = data.count;
		});
		this.activityLogService
			.getLazy(this.currentPage, this.pageSize, this.selectedFilters)
			.subscribe((data) => {
				this.activityLogs = data as ActivityLogFormatted[];
				this.activityLogs.forEach((activityLog) => {
					activityLog.formattedTime = Helper.FormateDate(activityLog.time, true);
					activityLog.signIpPort = `${activityLog.signIp}:${activityLog.signPort}`;
				});

				// this.populateFilters();
				this.loading = false;
			});
	}
	loadFilter(event, col) {
		// console.log(event, col);
		this.selectedFilters[col] = event;

		// Debounce
		if (this.timer) {
			clearTimeout(this.timer);
		}
		this.timer = setTimeout(() => {
			this.timer = null;
			this.loadData();
		}, 500);
		// console.log(this.selectedFilters);
	}

	// populateFilters() {
	//     const actions = Array.from(new Set(this.activityLogs.map(r => r.action)));
	//     const usernames = Array.from(new Set(this.activityLogs.map(r => r.username)));
	//     console.log('populate filters',actions,usernames)
	//     this.actionList=[];
	//     this.usernameList=[];
	//     actions.forEach(r => {
	//         let label = r;
	//         let value = r;
	//         this.actionList.push({ label, value });
	//     });

	//     usernames.forEach(u => {
	//         let label = u;
	//         let value = u;
	//         this.usernameList.push({ label, value });
	//     });
	// }

	loadMoreData(event) {
		console.log(event);
		this.currentPage = event.first / event.rows;
		this.loadData();
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/activity-log/activity-log.component.ts